import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';
import { Grid } from '@wds/grid';
import { Button, Typography } from '@sm/wds-react';
import { generateMetricsAttribute } from '@sm/metrics';
import { LinkIcon } from '../assets';
import COPY from '../assets/EnterpriseFeaturesCopy';
import useStyles from '../useStyles';

export default function MrxSection() {
  const { sectionTitle, centerText, addOnContainer } = useStyles();
  const cardKeys = ['conceptTesting', 'adTesting', 'brandTracking', 'priceOptimization', 'maxDiff'];
  const viewAllSolutionsUrl = 'https://www.surveymonkey.com/market-research/solutions/get-started';
  return (
    <>
      <Box display="flex" flexDirection="column" flexJustify="center">
        <Typography variant="pageTitle" className={`${sectionTitle} ${centerText}`}>
          Market Research Solutions
        </Typography>
        <Typography variant="body" className={centerText}>
          Explore our portfolio of AI-powered solutions.{' '}
          <a href={viewAllSolutionsUrl} target="_blank" rel="noreferrer">
            View all solutions
          </a>
        </Typography>
        <Grid className={addOnContainer} my={7} px={10}>
          {cardKeys.map(feature => {
            return (
              <Grid.Item xs={6} sm={6} md={6} lg={3.5} xl={3.5}>
                <MrxCard solution={COPY[feature]} />
              </Grid.Item>
            );
          })}
        </Grid>
      </Box>
    </>
  );
}

function MrxCard({ solution }) {
  const { addOnCardTitle, mrxButton, mrxCard, mrxCardInnerBox, mrxCardBody, linkIcon } = useStyles();

  const { title, body, image, learnMoreLink, ctaLink, desiredProduct } = solution;
  const { img, height, width } = image;

  return (
    <>
      <Box display="flex" flexDirection="column" className={mrxCard}>
        <Box display="flex" flexJustify="center" flexAlign="center" className={mrxCardInnerBox}>
          <img src={img} height={height} width={width} alt={title} />
        </Box>
        <p className={addOnCardTitle} variant="cardTitle">
          {title}
        </p>
        <Typography variant="body" className={mrxCardBody}>
          {body}{' '}
          <a href={learnMoreLink} target="_blank" rel="noreferrer">
            Learn more <img src={LinkIcon} className={linkIcon} alt="link" />
          </a>{' '}
        </Typography>
        <Button
          variant="solid"
          color="alt"
          className={mrxButton}
          target="_blank"
          rel="noreferrer"
          href={ctaLink}
          data-sm-metrics={generateMetricsAttribute({
            data: {
              desiredProduct,
              amplitudeEvent: 'pricing clicked enterprise cta',
            },
          })}
        >
          Get Started
        </Button>
      </Box>
    </>
  );
}

MrxCard.propTypes = {
  solution: PropTypes.shape(
    PropTypes.shape({
      title: PropTypes.string,
      body: PropTypes.string,
      link: PropTypes.string,
      ctaLink: PropTypes.string,
      desiredProduct: PropTypes.string,
      learnMoreLink: PropTypes.string,
      image: PropTypes.shape({
        img: PropTypes.node,
        height: PropTypes.string,
        width: PropTypes.string,
      }),
    })
  ).isRequired,
};
